import { defineComponent as m, inject as s, computed as f, h as i } from "vue";
import { inputInjectionKey as d } from "./ghl-ui.es1043.js";
import { len as p } from "./ghl-ui.es1044.js";
import { resolveSlotWithProps as c } from "./ghl-ui.es892.js";
const R = m({
  name: "InputWordCount",
  setup(v, { slots: o }) {
    const { mergedValueRef: t, maxlengthRef: u, mergedClsPrefixRef: a, countGraphemesRef: l } = (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      s(d)
    ), n = f(() => {
      const { value: e } = t;
      return e === null || Array.isArray(e) ? 0 : (l.value || p)(e);
    });
    return () => {
      const { value: e } = u, { value: r } = t;
      return i("span", { class: `${a.value}-input-word-count` }, c(o.default, {
        value: r === null || Array.isArray(r) ? "" : r
      }, () => [
        e === void 0 ? n.value : `${n.value} / ${e}`
      ]));
    };
  }
});
export {
  R as default
};
